import React from 'react';
import styled from 'styled-components';
import AlertCircleOutline from 'src/assets/images/AlertCircleOutline.svg';
import media from 'src/styles/Media.styled';

const AlertText = styled.div`
    font-family: 'AvenirNextWorld Regular';
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    letter-spacing: -0.1px;
    color: ${(props) => (props.color ? props.color : '#ED002A')};
    opacity: 1;
    padding: ${(props) => props.padding};
    ${media.mobileDevice`
        font-size: ${(props) => props.mbFontSize};
    `}
`;

const AlertMsg = ({ message, mbFontSize, mbHeight, mbWidth }) => {
    return (
        <>
            <img
                src={AlertCircleOutline}
                height={mbHeight ? mbHeight : '16px'}
                width={mbWidth ? mbWidth : '16px'}
                style={{ margin: '2px 6px 0 0' }}
            />
            <AlertText mbFontSize={mbFontSize}>{message}</AlertText>
        </>
    );
};

export default AlertMsg;
